import React, { ReactNode, Component } from 'react';
import { Heading } from '@nbc-design/heading';
import { getTextFactory } from 'utils/TextUtils';
import AboutYou from './components/AboutYou';
import CompletedCredentials from './components/CompletedCredentials';
import CredentialsCreation from './components/CredentialsCreation';
import EmailAlreadyExists from './components/EmailAlreadyExists';
import { CreateUserProfileProps, CreateUserProfileState } from './CreateUserProfile.type';
import { isAuthenticatedWith, OKTA_AUTHENT_TYPE } from '../../services/loginManager';
import { checkAccessTokenValidity } from '../../services/ssoRedirectService/oktaService';
import { CreateProfileStep } from './constant';
import { ROUTE } from '../../utils/constants';
import './styles.scss';
import getLogger from '../../utils/getLogger';

const logger = getLogger('Create profile');

class CreateUserProfile extends Component<CreateUserProfileProps, CreateUserProfileState> {
  private readonly setUserCredentials: Function;

  constructor(props: CreateUserProfileProps) {
    super(props);

    this.setState = this.setState.bind(this);
    this.setUserCredentials = this.props.setUserCredentials.bind(this);
  }

  state: CreateUserProfileState = {
    step: CreateProfileStep.CREDENTIALS_STEP,
    existingEmail: false,
    rejectedEmail: '',
    isError: false,
  };

  getText = getTextFactory(this.props.intl, 'createCredentials');

  profileCreationSteps = (step: number, isError: boolean) => (
    <div className="active-cards-wrapper">
      {step === CreateProfileStep.CREDENTIALS_STEP && (
        <CredentialsCreation
          intl={this.props.intl}
          history={this.props.history}
          setUserCredentials={this.setUserCredentials}
          setCardWrapperState={this.setState}
          isError={isError}
        />
      )}

      {step === CreateProfileStep.PERSONAL_INFO_STEP && (
        <CompletedCredentials intl={this.props.intl} setCardWrapperState={this.setState} />
      )}

      <AboutYou intl={this.props.intl} history={this.props.history} step={step} setCardWrapperState={this.setState} />
    </div>
  );

  componentDidMount() {
    const { history, intl } = this.props;
    window.addEventListener('pageshow', this.handlePageShow);

    // redirect user to welcome page if they are already authenticated with Okta and have a valid access token
    if (isAuthenticatedWith(OKTA_AUTHENT_TYPE)) {
      checkAccessTokenValidity(intl.locale)
        .then((accessToken) => {
          if (accessToken) {
            history.push({
              pathname: ROUTE.WELCOME,
            });
          }
        })
        .catch((err) => {
          logger.error(`Error on getting access token`, err);
        });
    }
  }

  componentWillUnmount() {
    window.removeEventListener('pageshow', this.handlePageShow);
  }

  handlePageShow = (event: PageTransitionEvent): void => {
    if (event.persisted) {
      window.location.reload();
    }
  };

  render(): ReactNode {
    const { step, existingEmail, rejectedEmail, isError } = this.state;

    return (
      <div className="layout-content">
        <div className="create-user-profile-wrapper">
          <Heading type="h1" className="my-2">
            {this.getText('pageTitle')}
          </Heading>
          {existingEmail ? (
            <EmailAlreadyExists intl={this.props.intl} email={rejectedEmail} />
          ) : (
            this.profileCreationSteps(step, isError)
          )}
        </div>
      </div>
    );
  }
}

export default CreateUserProfile;
